import { styled, SwitchProps, Switch, FormControlLabel } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { useState } from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { PlanItem } from './PlanItem';
import { Container, CustomFormControl, FlexContainer, PlansContainer, CustomText } from './PlanList.styles';
import { formattedStaticDateEnd } from 'shared/utils';

const mockPlans = [
  {
    name: 'Special Unlimited Media Intro Offer',
    images: 'Unlimited',
    video_audio: 'Unlimited',
    resume_skills: 'Unlimited',
    multiple_profiles: true,
    castingapp_noticeboard: 'Full Access',
    image_changes: 'Unlimited',
    cost: 0,
    remarks: (
      <Typography color="primary" fontSize={14}>
        Offer Available Until {formattedStaticDateEnd}
      </Typography>
    ),
    disclaimer: (
      <CustomText size={14}>
        <span style={{ color: '#e62727' }}>*</span>Special consideration, all media uploaded in this period will be
        considered &quot;Grandfathered in&quot; and will never be removed and remain free ongoing regardless of the plan
        selected.
      </CustomText>
    ),
    active: true,
    img_url: '/plans/special-6-month.svg',
  },
  {
    name: 'Basic Plan',
    images: '2x Images',
    video_audio: '1x Video/Audio',
    resume_skills: 'Unlimited',
    multiple_profiles: true,
    castingapp_noticeboard: "Can't Submit",
    image_changes: '1 / year',
    cost: 0,
    // remarks: (
    //   <Typography fontSize={14}>
    //     <span style={{ color: '#e62727' }}>*</span>$20 annual fee applies after first year
    //   </Typography>
    // ),
    disclaimer: '',
    active: false,
    img_url: '/plans/basic-plan.svg',
  },
  {
    name: 'Premium Plan',
    images: 'Unlimited',
    video_audio: 'Unlimited',
    resume_skills: 'Unlimited',
    multiple_profiles: true,
    castingapp_noticeboard: 'Full Access',
    image_changes: 'Unlimited',
    cost: 10,
    remarks: '',
    disclaimer: '',
    active: false,
    img_url: '/plans/premium-plan.svg',
  },
];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: '0 20px 0 10px',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: COLORS.PRIMARY,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#fff',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#1c2531',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const PlanList = () => {
  const [method, setMethod] = useState<string>('month');

  const onToggle = (isChecked: any) => {
    if (isChecked) setMethod('annual');
    else setMethod('month');
  };

  return (
    <Container>
      <FlexContainer>
        <p style={{ fontSize: 25 }}>Plans</p>
        <FlexContainer style={{ flexDirection: 'row' }}>
          <Typography>Monthly</Typography>
          <CustomFormControl
            control={<IOSSwitch />}
            label=""
            value={method === 'monthly'}
            onChange={(e: any) => onToggle(e.target.checked)}
          />
          <p style={{ fontSize: 16 }}>Annually (Save 20%)</p>
        </FlexContainer>
      </FlexContainer>
      <PlansContainer>
        {mockPlans.map((i, index) => (
          <PlanItem data={i} key={`Plan-Item--${index}`} method={method} />
        ))}
      </PlansContainer>
    </Container>
  );
};

export default PlanList;
